const rsTipoUso = [
  { value: '0', detalle: 'Residencial' },
  { value: '1', detalle: 'Comercial' },
  { value: '2', detalle: 'Industrial' },
  { value: '3', detalle: 'Oficial' },
  { value: '4', detalle: 'Alumbrado público' },
  { value: '5', detalle: 'Provisional' },
  { value: '6', detalle: 'Otro' },
];

export default rsTipoUso;
